import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NodeTitle from "./noteTitle";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { useSelector, useDispatch } from "react-redux";
import {
  applyCouponInCart,
  validateCoupon,
} from "../../redux/reducer/couponsReducer";
import { fetchMyCarts } from "../../redux/reducer/cartReducer";
import StatusModal from "./StatusModal";

const PaymentDetails = ({
  time,
  status,
  couponValue,
  usedCoupon,
  cardStatus,
  totalPrice,
  totalPriceWithFees,
  finalPrice,
  priceInside,
}) => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const [timeLeft, setTimeLeft] = useState(time);
  const dispatch = useDispatch();
  const { validatedCoupon } = useSelector((state) => state.coupon);
  const [showCouponForm, setShowCouponForm] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  // const [activeSubmit, setActiveSubmit] = useState(true);
  // const [showCoupon, setShowCoupon] = useState(false);
  // const [lastSubmittedCoupon, setLastSubmittedCoupon] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalStatus, setModalStatus] = useState(null);
  const [modalMessage, setModalMessage] = useState("");
  const { selectedCoupon } = useSelector((state) => state.coupon);
  // const { selectCoupon, setSelectCoupon } = useState(null);
  // const [selectedCoupon] =
  // console.log(status);
  useEffect(() => {
    // console.log("Selected coupon changed:", selectedCoupon);
    // أي تحديث أو side effect تحبه
  }, [selectedCoupon]);
  useEffect(() => {
    if (typeof time === "number") {
      setTimeLeft(time);
    } else if (typeof time === "string") {
      // If the time is a string, we try to convert it to seconds
      const timeParts = time.split(":");
      let totalSeconds = 0;

      if (timeParts.length === 2) {
        // MM:SS format
        totalSeconds = parseInt(timeParts[0]) * 60 + parseInt(timeParts[1]);
      } else if (timeParts.length === 3) {
        // HH:MM:SS format
        totalSeconds =
          parseInt(timeParts[0]) * 3600 +
          parseInt(timeParts[1]) * 60 +
          parseInt(timeParts[2]);
      }

      setTimeLeft(totalSeconds);
    }
  }, [time]);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  // useEffect(() => {
  //   if (validatedCoupon) {
  //     // setShowCoupon(true);
  //     const timer = setTimeout(() => {
  //       // setShowCoupon(false);
  //     }, 7000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [validatedCoupon]);
  // Convert seconds to HH:MM:SS or MM:SS format
  const formatTime = (seconds) => {
    if (seconds <= 0) return "00:00";

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) {
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    } else {
      return `${minutes.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    }
  };

  const roundToTwo = (num) => parseFloat(Number(num).toFixed(2));
  const currencySymbol = getCurrencyAndLanguageSymbol();

  const handleSubmitCoupin = async (code) => {
    try {
      // await dispatch(applyCouponInCart(code)).unwrap();
      const result = await dispatch(applyCouponInCart(code)).unwrap();
      // console.log(result);
      // setSelectCoupon(result);
      // await dispatch(fetchMyCarts()).unwrap();
      setModalMessage(t("thankSuccessCodeCoupon"));
      setModalStatus("success");
      setShowModal(true);
      return;
    } catch (error) {
      if (error?.code === 400) {
        setModalStatus("error");
        setModalMessage(t("currentAmountBelowRequiredMinimum"));
        setShowModal(true);
      } else {
        setModalMessage(t("thankSuccessCodeCoupon"));
        setModalStatus("success");
        setShowModal(true);
      }
    }
  };

  const handleCheckCoupin = async (code) => {
    if (!code) {
      setError(t("couponNotFoundV1"));
      return;
    }

    if (code.length < 3) {
      setError(t("couponMustBeMoreThan3Chars"));
      return;
    }
    // console.log(code);
    try {
      await dispatch(validateCoupon(code)).unwrap();
      // setActiveSubmit(false);
      // setShowCoupon(true);
      // setLastSubmittedCoupon(code);
      handleSubmitCoupin(code);
    } catch (error) {
      // console.error("Failed to Coupon:", error);
      if (error?.code === 403) {
        // setError(t("couponNotAssignedtoyou"));
        setModalStatus("error");
        setShowModal(true);
        setModalMessage(t("couponNotAssignedtoyou"));
      } else if (error?.code === 400) {
        // setError(t("couponHasExpired"));
        setModalStatus("error");
        setShowModal(true);
        setModalMessage(t("couponHasExpired"));
      } else {
        // setError(t("couponNotFound") ? t("couponNotFound") : error?.message);
        setModalStatus("error");
        setShowModal(true);
        setModalMessage(t("couponNotFound"));
      }
    }
    // finally {
    //   handleSubmitCoupin(code);
    // }
  };
  // console.log(selectCoupon);
  // console.log(couponCode !== lastSubmittedCoupon);
  return (
    <div className="flex items-center justify-center ">
      <div className="w-full space-y-8" dir={direction}>
        {/* Header Section */}
        <div className="grid grid-cols-2 gap-4 lg:gap-8">
          <div className="flex flex-col">
            <span className="mb-1 font-medium text-gray-500">
              {t("status")}
            </span>
            <div className="p-4 bg-white border ">
              <span className="text-xs font-bold text-black lg:text-lg">
                {direction === "rtl" ? status.ar : status.en}
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            <span className="mb-1 font-medium text-gray-500">
              {" "}
              {t("time_left_to_pay")}
            </span>
            <div className="p-4 bg-white border ">
              {timeLeft === 0 ? (
                <span className={`text-sm font-bold lg:text-lg text-black`}>
                  {t("waiting")}
                </span>
              ) : (
                <span
                  className={`text-sm font-bold lg:text-lg ${
                    timeLeft <= 60 ? "text-red-500" : "text-black"
                  }`}
                >
                  {formatTime(timeLeft)}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-3 lg:gap-8">
          <div className="flex flex-col">
            <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
              {t("total_purchase_price")}
            </span>
            <div className="p-4 bg-white border rounded-md">
              <span className="text-sm font-bold text-black lg:text-lg">
                {roundToTwo(Number(totalPrice))} {currencySymbol}
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
              {t("fees_and_commissions")}
              <span className="relative inline-block">
                {t("fees_Before")}
                <span class="absolute left-0 top-1/2 w-full h-[1.5px] bg-gray-700 translate-y-[-70%]"></span>
              </span>
              {t("fees_After")}
            </span>
            <div className="p-4 bg-white border rounded-md">
              <span className="text-sm font-bold text-black lg:text-lg">
                {roundToTwo(Number(totalPriceWithFees))} {currencySymbol}
              </span>
            </div>
          </div>
          <div className="flex flex-col">
            <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
              {t("internal_shipping_fees")}
            </span>
            <div className="p-4 bg-white border rounded-md">
              <span className="text-sm font-bold text-black lg:text-lg">
                {roundToTwo(Number(priceInside))} {currencySymbol}
              </span>
            </div>
          </div>
        </div>
        {/* Total Section */}
        {/* {!selectedCoupon && (
          <div className="flex flex-col ">
            <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
              {t("final_total")}
            </span>
            <div className="p-4 bg-white border rounded-md">
              <span className="text-base font-bold text-black">
                {roundToTwo(Number(finalPrice))} {currencySymbol}
              </span>
            </div>
          </div>
        )} */}
        {selectedCoupon ? (
          <>
            <div className="flex flex-col">
              <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
                {t("final_total")}
              </span>
              <div className="flex gap-4 p-4 bg-white border rounded-md">
                <>
                  <span className="text-base font-bold text-green-700">
                    {roundToTwo(Number(selectedCoupon?.cart?.afterCartPrice))}{" "}
                    {currencySymbol}
                  </span>

                  <span className="text-base font-bold text-gray-600 line-through">
                    {roundToTwo(Number(selectedCoupon?.cart?.beforeCartPrice))}{" "}
                    {currencySymbol}
                  </span>
                </>
              </div>
            </div>
          </>
        ) : !usedCoupon ? (
          <div className="flex flex-col ">
            <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
              {t("final_total")}
            </span>
            <div className="p-4 bg-white border rounded-md">
              <span className="text-base font-bold text-black">
                {roundToTwo(Number(finalPrice))} {currencySymbol}
              </span>
            </div>
          </div>
        ) : (
          <>
            <div className="flex flex-col">
              <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
                {t("final_total")}
              </span>
              <div className="flex gap-4 p-4 bg-white border rounded-md">
                <>
                  <span className="text-base font-bold text-green-700">
                    {roundToTwo(Number(finalPrice))} {currencySymbol}
                  </span>
                  <span className="text-base font-bold text-gray-600 line-through">
                    {roundToTwo(Number(finalPrice) + Number(couponValue))}{" "}
                    {currencySymbol}
                  </span>
                </>
              </div>
            </div>
          </>
        )}
        {/* {usedCoupon && (
          <>
            <div className="flex flex-col">
              <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
                {t("total")}
              </span>
              <div className="p-4 bg-white border rounded-md">
                <span className="text-base font-bold text-black">
                  {roundToTwo(Number(finalPrice) + Number(couponValue))}{" "}
                  {currencySymbol}
                </span>
              </div>
            </div>
            <div className="flex flex-col">
              <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
                {t("discountValue")}
              </span>
              <div className="p-4 bg-white border rounded-md">
                <span className="text-base font-bold text-black">
                  {roundToTwo(Number(couponValue))} {currencySymbol}
                </span>
              </div>
            </div>
            <div className="flex flex-col">
              <span className="mb-1 text-sm font-medium text-gray-500 lg:text-base">
                {t("final_total")}
              </span>
              <div className="p-4 bg-white border rounded-md">
                <span className="text-base font-bold text-black">
                  {roundToTwo(Number(finalPrice))} {currencySymbol}
                </span>
              </div>
            </div>
          </>
        )} */}

        {/* Add Coupon Button */}
        {cardStatus === "priced" && (
          <div className="flex flex-col justify-start gap-4 mb-4 ">
            <button
              type="button"
              className="flex items-center gap-2 text-gray-500 duration-300 text-custom hover:text-black group"
              onClick={() => setShowCouponForm((prev) => !prev)}
            >
              <ChevronDownIcon className="w-5 h-5 text-gray-500 duration-300 group-hover:text-black " />
              {t("HaveDiscountCode")}
            </button>

            {showCouponForm && (
              <>
                <div className="inline-flex items-center w-full gap-3 px-3 py-2 mt-2 bg-white border border-gray-200 rounded-md md:w-1/2">
                  <input
                    type="text"
                    placeholder="e.g. Coupon25"
                    min="4"
                    value={couponCode}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCouponCode(value);
                    }}
                    className="w-full px-3 py-2 text-gray-800 rounded-l-lg focus:outline-none 
                    [-moz-appearance:textfield] 
                    [&::-webkit-outer-spin-button]:appearance-none 
                    [&::-webkit-inner-spin-button]:appearance-none"
                  />
                  <button
                    type="button"
                    className={`flex items-center gap-3 px-3 py-1 border hover:border-black hover:bg-black group text-black bg-custom-yellow duration-300 rounded-md`}
                    onClick={() => handleCheckCoupin(couponCode)}
                  >
                    <span className="mx-4 text-black duration-300 group-hover:text-white">
                      {t("apply")}
                    </span>
                  </button>
                  {/* <button
                    type="button"
                    className={`flex items-center gap-3 px-3 py-1 border 
                    duration-300
                    ${
                      activeSubmit || !(couponCode === lastSubmittedCoupon)
                        ? "bg-gray-300 border-gray-300 text-gray-500 cursor-not-allowed"
                        : "bg-custom-yellow text-black border hover:border-black hover:bg-black group"
                    }`}
                    onClick={() => handleSubmitCoupin(couponCode)}
                    disabled={
                      activeSubmit || !(couponCode === lastSubmittedCoupon)
                    }
                  >
                    <span
                      className={`mx-4 duration-300 ${
                        activeSubmit || !(couponCode === lastSubmittedCoupon)
                          ? "text-gray-500"
                          : "text-black group-hover:text-white"
                      }`}
                    >
                      {t("Submit")}
                    </span>
                  </button> */}
                </div>
                {/* {showCoupon && validatedCoupon && (
                  <>
                    <p className="text-sm text-green-700">
                      <span>{t("discountCoupon")}</span>{" "}
                      <span>
                        {roundToTwo(Number(validatedCoupon?.discount))}
                      </span>{" "}
                      <span>{currencySymbol}</span>
                    </p>
                  </>
                )} */}
              </>
            )}
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
          </div>
        )}
        <NodeTitle />
      </div>
      <StatusModal
        isOpen={showModal}
        onClose={() => setShowModal(!showModal)}
        status={modalStatus}
        title={
          modalStatus === "error"
            ? t("codeError")
            : t("codeSuccessfullyRegistered")
        }
        message={modalMessage}
        autoCloseDuration={2000}
      />
    </div>
  );
};

export default PaymentDetails;
